import React from 'react';

// Historically this component was responsible to catch all rendering failures and to send them to DataDog RUM
// In June 2025 we deprecated the DataDog in favor of Grafana + Sentry, yet we didn't migrate the CH App to any of those
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
